<template>
<v-card flat tile >
  <v-window vertical v-model="active" class="grey lighten-4" >
    <v-tabs v-if="!newMembersOnly"
      v-model='activeTab' >
      <v-tab @click="clearAction" >
        <v-icon>mdi-home</v-icon>
      </v-tab>
      <v-tab
        v-for="option in inviteOptions"
        @click="setAction(option)"
        :disabled="!option.component"
        :key="option.title" >{{ option.title }}</v-tab>
    </v-tabs>

    <v-window-item v-if="!newMembersOnly" >
      <v-row class="px-4" >
        <v-col cols="12" >
          <h2 class="text-md-h5" >Add a new member to your team</h2>
        </v-col>
        <v-col cols="4" class="my-3" v-for="option in inviteOptions" :key="option.title" >
          <v-card height="100%" class="d-flex flex-column" flat tile >
            <v-card-title class='subtitle-1 overline' v-text="option.title" />
            <v-card-text class="grow" v-text="option.description" />
            <v-card-actions >
              <v-btn block color="primary"
                :disabled="!option.component"
                @click="setAction(option)" >Select</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-window-item>

    <v-window-item >
      <!-- <validate-email @validated="handleValidation" /> -->
      <template v-if="inviteComponent" >
        <component v-if="inviteComponent" :is="inviteComponent" v-model="member" />
        <!-- {{member}} -->
      </template>
    </v-window-item >

    <!-- <pre v-text="invite" /> -->
    <!-- <v-toolbar >
      <v-btn @click="active--" > prev </v-btn >
      <v-btn @click="active++" > next </v-btn >
    </v-toolbar> -->
  </v-window>

  <!-- <v-toolbar >
    <v-btn @click="active--" > prev </v-btn >
    <v-btn @click="active++" > next </v-btn >
  </v-toolbar> -->
</v-card>
</template>
<script>
// import PerformInvite from './PerformInvite.vue'
import CreateMember from './CreateMember.vue'
import AddColleague from './AddColleague.vue'
import InviteMember from './InviteMember.vue'
import Terms from './Terms.vue'
import ValidateEmail from './ValidateEmail.vue'
// import ExistingMember from './ExistingMember.vue'

// import CopyTextField from '@/components/ui/CopyTextField.vue'
// import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  name: 'InviteMemberWizard',
  components: {
    Terms,
    // PerformInvite,
    // CopyTextField,
    CreateMember,
    ValidateEmail
  },
  props: {
    spaceId: { required: false },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      newMembersOnly: true,
      active: 0,
      activeTab: null,
      invite: {
        spaces: null
      },
      tandcs: false,
      member: {
        email: null
      },
      inviteComponent: null
    }
  },
  mounted () { this.init() },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        this.init()
        // if (this.spaceId) {
        //   Vue.set(this.invite, 'space', this.spaceId)
        //   this.active = 2
        // } else {
        //   this.active = 1
        // }
      }
    },
    touch () {
      this.init()
    }
  },
  methods: {
    init () {
      this.active = 0
      if (this.newMembersOnly) {
        this.setAction(this.inviteOptions[0])
      }
    },
    inviteCreated (invite) {
      this.$emit('saved', invite)
      this.active++
    },
    handleValidation (res) {
      this.inviteType = res.type
      this.member.email = res.email
    },
    setAction (action) {
      this.inviteComponent = action.component
      this.activeTab = action.tabIndex
      this.active = 1
    },
    clearAction () {
      this.inviteComponent = null
      this.activeTab = 0
      this.active = 0
    }
  },
  computed: {
    ...mapGetters('identity', ['getSpaceById']),
    space () {
      if (this.invite && this.invite.space) {
        return this.getSpaceById(this.invite.space)
      }
      return null
    },
    inviteLink () {
      return this.getObjectPath(this.invite, 'join_link', null)
    },
    // inviteComponent () {
    //   if (this.inviteType === 'NEW') { return CreateMember }
    //   if (this.inviteType === 'ACTIVE') { return ExistingMember }
    //   return null
    // },
    inviteOptions () {
      return [
        {
          title: 'New member',
          description: 'Add a new member as a dependent',
          component: CreateMember,
          tabIndex: 1
        },
        {
          title: 'Add colleague',
          description: 'Add an existing colleague from another space that you own',
          component: AddColleague,
          tabIndex: 2
        },
        {
          title: 'Invite',
          description: 'Invite someone with an existing AppointmentGuru account to your space',
          component: InviteMember,
          tabIndex: 3
        }
      ]
    }
  }
}
</script>
